var React = require('react');

function Tooltip (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon"},React.createElement("path",{"id":"Vector","d":"M7.33333 4.66665H8.66666V5.99998H7.33333V4.66665ZM7.33333 7.33331H8.66666V11.3333H7.33333V7.33331ZM8 1.33331C4.31999 1.33331 1.33333 4.31998 1.33333 7.99998C1.33333 11.68 4.31999 14.6666 8 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8 1.33331ZM8 13.3333C5.06 13.3333 2.66666 10.94 2.66666 7.99998C2.66666 5.05998 5.06 2.66665 8 2.66665C10.94 2.66665 13.3333 5.05998 13.3333 7.99998C13.3333 10.94 10.94 13.3333 8 13.3333Z","fill":"#0467D2"})));
}

Tooltip.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Tooltip;

Tooltip.default = Tooltip;
